import React from 'react';
import { histogram } from 'd3-array';
import { ResponsiveOrdinalFrame } from 'semiotic';

import './Histogram.css';

const buckets = histogram().value(({v}) => v);

const Histogram = ({data, width, highlight}) => {
  const prepped = buckets.thresholds(width > 500 ? 256 : 128)(data).map(d => {
    if ( d.x0 <= highlight && d.x1 >= highlight ) {
      d.color = 'red';
      d.stroke = 'red';
    } else {
      d.color = '#00a2ce';
      d.stroke = 'white';
    }
    return d;
  });
  return (
    <div className="histogram">
      <div style={{fontSize: "22px"}}>Distribution of funding for schools in 2016</div>
      <ResponsiveOrdinalFrame
        size={[width - 50, 400]}
        data={prepped}
        oAccessor={"x0"}
        rAccessor={"length"}
        style={(d,i,n) => {
          return { fill: d.color, stroke: d.stroke }
        }}
        type={"bar"}
        axis={{ orient: "left", label: "Number of schools " }}
        margin={{ left: 70, bottom: 50, right: 5, top: 5 }}
        oLabel={(d, i, n) => {
          return (
            n % 40 === 0 ? <text className="x-label" transform="translate(-15,10)">{`$${Math.round(d/1000).toLocaleString()}k`}</text> : <g/>
          )}}
          rLabel={true}
        />
        <div>Funding per student ($000)</div>
      </div>
  )};

export default Histogram;





// WEBPACK FOOTER //
// ./src/Histogram.js